import React from 'react';
export default class ElegantResumeEmployment extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        

        if (data.companyName){
            title.push(<span key="b" data-v-5a80631c="">{data.companyName}</span>)
        }

        if (data.location){
            title.push(<span  key="c" data-v-5a80631c="">{data.location}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span key={i} data-v-5a80631c="" className="comma">, </span>)
            }
        }

        return  <div data-v-5a80631c="" className="section-item" key={index}>
					<div data-v-5a80631c="" className="section-meta">
                        {titleFinal}
                    </div>
                    {data.endDate && data.startDate && <div data-v-5a80631c="" className="section-title"><div data-v-5a80631c="" className="section-date"><b data-v-5a80631c="">{data.jobTitle}</b><span data-v-5a80631c="">/</span>
                        <span className="date" data-v-5a80631c="">{data.startDate.toUpperCase()} -</span>
                        <span className="date" data-v-5a80631c="">{data.endDate.toUpperCase()}</span>
                    </div></div>}
                    
                    <div data-v-5a80631c="" className="section-description" dangerouslySetInnerHTML={{ __html: data.description }}></div>
                </div>
    }

    render(){
        return  <div data-v-5a80631c="" className="section">
                    <div data-v-5a80631c="" className="section-headline">{this.props.title}</div>
                    {this.props.data.map((item, index) => {
                        return this.getResumeBlock(item, index);
                    })}
                </div>

    }
}